import axios from "@/utils/request";

function LOG_TOKEN_DETAILS(params) {
  return axios.get("/translation/BatchTranslation/logTokenDetails", {
    params: params
  });
}

export default {
  LOG_TOKEN_DETAILS
};
